// extracted by mini-css-extract-plugin
export default {"schedule":"WorkSchedule_schedule__6SssW","day":"WorkSchedule_day__rjf12","active":"WorkSchedule_active__nexvp","inactive":"WorkSchedule_inactive__0LlqA"};